import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import queryString from 'query-string';
import $ from 'jquery';
import Hls from 'hls.js';
import dashjs from 'dashjs';
import md5 from 'js-md5';
import moment from 'moment';
import ActivateForm from './ActivateForm';
import Channels from './Channels';
import DeviceRevoked from './DeviceRevoked';
import VideoArea from './VideoArea';
import Programs from './Programs';
import VideoTitle from './VideoTitle';
import VideoStatus from './VideoStatus';
import VideoControls from './VideoControls';
import VideoPlayback from './VideoPlayback';
import Detail from './Detail';
import OutsideSubtitle from './OutsideSubtitle';
import MultiVideoArea from './MultiVideoArea';
import ProgramLink from './ProgramLink';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import AribSubtitleStreamController from '../hlsjs/arib-subtitle-stream-controller.js';
import AribSubtitleTrackController from '../hlsjs/arib-subtitle-track-controller.js';

const theme = createMuiTheme({
  slider: {
    rippleColor: grey[100],
    selectionColor: grey[100],
    handleFillColor: grey[100]
  }
});

const App = () => (
  <BrowserRouter>
    <div>
      <Route exact path='/' component={Main} />
      <Route exact path='/:channelId' component={Main} />
      <Route exact path='/:channelId/:eventId' component={Main} />
    </div>
  </BrowserRouter>
)

class Main extends React.Component {
  state = {
    requireActivate: false,
    channelLoaded: false,
    overlayFixed: false,
    status: 'TVMock起動…',
    isMulti: false,
    overlay: false,
    currentPlaybackRate: 1
  }
  constructor(props) {
    super(props);
    this.version = '1.0.5 (6)';
    this.magicSalt = 'ieb3ahYuquohz3joopiH';
  }
  fetchConfig = () => {
    console.log('fetchConfig');
    this.setState({state: '設定ファイル取得中…'});
    //var url = "../stub/config.json";
    const url = "https://tvmock-configuration.s3-ap-northeast-1.amazonaws.com/config.json"; // demo
    var self = this;
    $.ajax({
      method:'get',
      url: url,
      data: {},
      dataType: 'json',
      cache: false,
      //cache: false,
      success: (data) => {
        self.setState({baseUrl: data.api.baseUrl});
        //TODO サーバ配備時は有効にする
        // this.registerServiceWorker((pushId) => {
        //   this.registerDevice(pushId);
        // });
        const pushId = self.getDummyPushId();
        self.registerDevice(pushId);
      },
      error: (xhr, status, err) => {
        console.error(url, status, err.toString());
      }
    });
  };
  getDummyPushId = () => {
    var pushId = this.state.pushId;
    if (pushId === undefined) {
      pushId = localStorage.getItem('pushId');
    }
    if (pushId === null) {
      pushId = this.generateUuid();
      this.setState({push_id: pushId});
      localStorage.setItem('pushId', pushId);
    }
    return pushId;
  };
  generateUuid = () => {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  };
  getIdentityToken = () => {
    //return Cookies.get('identity_token');
    return;
  };
  getIdentityTokenSecret = () => {
    //return Cookies.get('identity_token_secret');
    return;
  };
  registerServiceWorker = (callback) => {
    console.log('registerServiceWorker');

    navigator.serviceWorker.register('service_worker.js');
    Notification.requestPermission(state => {
      console.log(state);
      if (state === 'granted') {
        this.readyServiceWorker(callback);
      }
    });
  };
  readyServiceWorker = (callback) => {
    console.log('readyServiceWorker');
    navigator.serviceWorker.ready
      .then((registration) => {
        console.log(registration);
        return registration.pushManager.subscribe({userVisibleOnly: true});
      })
      .then((subscription) => {
        console.log(subscription);
        callback(subscription.endpoint);
    })
    .catch(console.error.bind(console));
  };
  sign = (data, order, salt, hashKey) => {
    console.log('sign');
    var vals = salt;
    $(order).each(function() {
      var key = this;
      if (data[key] !== undefined) {
        vals += data[key];
      }
    });
    data[hashKey] = md5(vals);
  };
  registerDevice = (pushId) => {
    this.setState({state: '認証処理中…'});
    var url = this.state['baseUrl'];
    if (this.getIdentityToken() !== undefined) {
      url += '/devices/update.json';
    } else {
      url += '/devices/create.json';
    }
    var data = {
      d: pushId,
      v: this.version,
      s: navigator.platform,
      o: navigator.userAgent,
      m: '-',
      c: '-'//,
      // i: this.getDeviceId()
    };
    var identityToken = this.getIdentityToken();
    if (identityToken !== undefined) {
      data['t'] = identityToken;
    }
    var order = ['t', 'd', 'v', 's', 'o', 'm', 'c', 'i'];
    this.sign(data, order, this.magicSalt, 'h');
    var self = this;
    $.ajax({
      method:'post',
      url: url,
      data: data,
      dataType: 'json',
      cache: false,
      xhrFields: {withCredentials: true},
      success: (data) => {
        self.setState({
          identityToken: data.identity_token,
          identityTokenSecret: data.identity_token_secret,
          individualId: data.individual_id
        });
        self.fetchChannels();
      },
      error: (xhr, status, err) => {
        if (xhr.status === 403) {
          var code = xhr.responseJSON['code'];
          if (code === 2901) {
            var individualId = xhr.responseJSON['individual_id'];
            self.setState({
              individualId: individualId,
              requireActivate: true,
              status:'activate'
            });
          }
          else {
            individualId = xhr.responseJSON['individual_id'];
            self.setState({
              individualId: individualId,
              status: 'revoked'
            });
          }
        }
        console.error(url, status, err.toString());
      }
    });
  };
  playChannel = (service) => {
    localStorage.setItem('activeServiceId', service.service_id);
    this.setState({
      videoType: 'live',
      service: service,
      program: undefined,
      activeServiceId: service.service_id
    });
    this.fetchChannelProgram(service, undefined,(program) => {
      this.playVideo(this.createChannelVideoUrl(service), this.createProgramVideoUrl(program));
    });
  };

  onLoadPrograms = (programs) => {
    this.setState({programs: programs});
  };

  playProgramFromUnixTime = (service, unixTime) => {
    localStorage.setItem('activeServiceId', service.service_id);
    this.setState({
      videoType: 'timeshift',
      service: service,
      program: undefined,
      activeServiceId: service.service_id
    });
    this.fetchChannelProgram(service, unixTime,(program) => {
      const position = unixTime/1000 - program.start_time;
      this.playProgram(program, service, position);
    });
  };

  playProgramFromEventId = (eventId, service, position) => {
    this.setState({service: service, activeServiceId: service.service_id});
    this.fetchProgramItem([eventId], false, undefined, (program) => {
      this.playProgram(program, service, position);
    });
  };

  playProgram = (program, service, position) => {
    if (service !== undefined) {
      localStorage.setItem('activeServiceId', service.service_id);
      this.state.service = service;
      this.state.activeServiceId =service.service_id;
    }
    this.setState({
      videoType: 'timeshift',
      program: program
    });
    const videoUrl = this.createProgramVideoUrl(program);
    // stateが反映された後に呼ばれるように非同期にする。
    setTimeout(() => this.playVideo(videoUrl, videoUrl, position), 0);
  };

  playVideo = (videoUrl, previewUrl, position) => {
    this.playWithHls(videoUrl, previewUrl, position);
    //this.playWithDash(videoUrl, previewUrl, position);
  };

  playWithHls = (videoUrl, previewUrl, position) => {
    //videoUrl = 'http://192.168.1.11/tv/7fe07fe00400/playlist_index_vtt.m3u8';
    const video = document.getElementById('video');
    //video.setAttribute('poster', this.state.service.logo_image_url); // ちらつく
    //for hls.js
    if(Hls.isSupported()) {
      if (this.hls !== undefined) {
        this.hls.detachMedia();
        this.hls.destroy();
        // reset
        this.setState({'currentSubtitle': ''});
        this.setState({currentPlaybackRate: 1});
      }
      const identityToken = this.state.identityToken;
      // for s3 test
      var expires = new Date();
      expires.setDate(expires.getDate() + 365);
      document.cookie = 'identity_token=' +identityToken +';path=/;domain=.tvapp.jp;expires=' + expires.toUTCString();
      //!
      const xhrSetup = (xhr, url) => {
        if (url.indexOf('video.key') !== -1) {
          xhr.withCredentials = true;
          xhr.open('GET', url, true);
        } else if (url.indexOf('"') !== -1) {
          url = url.replace(/"/g, '');
          xhr.open('GET', url, true);
        }
      };
      let subtitleUrl;
      const channelId = this.getChannelId(this.state.service);
      if (this.state.videoType === 'live') {
        subtitleUrl = 'https://demo-cc01.tvapp.jp/apps/subpac/' +channelId +'/caption.m3u8';
      } else {
        const program = this.state.program;
        const startTime = moment(program.start_time*1000).format('YYYYMMDDHHmmss000');
        subtitleUrl = 'https://demo-cc01.tvapp.jp/apps/subpac/' +channelId +'/caption_ts_' +startTime +'.m3u8';
      }
      const hlsConfig = {
        debug: this.debug,
        subtitleStreamController: AribSubtitleStreamController,
        subtitleTrackController: AribSubtitleTrackController,
        useNativeRendering: false, // default false
        useAribSubtitleXml: false, // default false
        adjustWithPDT: true,
        subtitleUrl: subtitleUrl,
        xhrSetup: xhrSetup
      };
      this.hls = new Hls(hlsConfig);
      this.hls.loadSource(videoUrl);
      //this.hls.loadSource("https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_ts/master.m3u8");
      this.hls.attachMedia(video);

      //this.playSubtitle(videoUrl);

      const preview = document.getElementById('preview');
      this.previewHls = new Hls({
        xhrSetup: xhrSetup
      });
      this.previewHls.loadSource(previewUrl);
      this.previewHls.attachMedia(preview);
      this.previewHls.on(Hls.Events.MANIFEST_PARSED, () => {
        let minBitrate = Number.MAX_VALUE;
        let minLevelIndex = undefined;
        this.previewHls.levels.forEach((level, index) => {
          if (level.bitrate < minBitrate) {
            minBitrate = level.bitrate;
            minLevelIndex = index;
          }
        });
        if (minLevelIndex) {
          this.previewHls.loadLevel = minLevelIndex;
          this.previewHls.startLoad();
        }
      });
      const self = this;
      //https://github.com/video-dev/hls.js/blob/master/doc/API.md#runtime-events
      this.hls.on(Hls.Events.MANIFEST_PARSED,() => {
        console.log('Hls.Events.MANIFEST_PARSED');
        self.setState({
          currentLevel: self.hls.currentLevel,
          qualityLevels: self.hls.levels
        });
        //$(video).fadeIn();
        video.play();
      });
      this.hls.on(Hls.Events.MANIFEST_LOADED, () => {
        console.log('Hls.Events.MANIFEST_LOADED');
        if (position !== undefined) {
          video.currentTime = position;
          preview.currentTime = position;
        }
        self.setState({
          currentAudioTrack: self.hls.audioTrack,
          audioTracks: self.hls.audioTracks
        });
      });
      this.hls.on(Hls.Events.SUBTITLE_TRACKS_UPDATED, function(event, data) {
        console.log('Hls.Events.SUBTITLE_TRACKS_UPDATED ');
        console.log(self.hls.subtitleTracks);
        const subtitleMode = self.state.currentSubtitleMode;
        if (subtitleMode) {
          video.textTracks.forEach(track => {
            //track.mode = subtitleMode === 'hidden'? 'hidden' : 'showing';
            track.showMode = subtitleMode;
          });
          setTimeout(() => video.textTracks.dispatchEvent(new Event('change')), 0);
        }
      });
      // this.hls.on(Hls.Events.SUBTITLE_TRACK_SWITCH, function(event, data) {
      //   console.log('Hls.Events.SUBTITLE_TRACK_SWITCH ');
      // });
      // this.hls.on(Hls.Events.SUBTITLE_TRACK_LOADED, function(event, data) {
      //   console.log('Hls.Events.SUBTITLE_TRACK_LOADED ');
      // });
      // this.hls.on(Hls.Events.SUBTITLE_FRAG_PROCESSED, function(event, data) {
      //   console.log('Hls.Events.SUBTITLE_FRAG_PROCESSED ');
      // });
      // this.hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, function(event, data) {
      //   console.log('Hls.Events.AUDIO_TRACK_SWITCHED ' + self.hls.audioTrack);
      // });
      this.hls.on(Hls.Events.FRAG_CHANGED, function(event,data) {
        if (data.frag.rawProgramDateTime) {
          //const utime = data.frag.programDateTime.getTime(); // safari not work.
          const utime = moment(data.frag.rawProgramDateTime).valueOf();
          const baseVideoTime = video.currentTime * 1000;
          const updateCurrentTime = () => {
            const videoTime = video.currentTime * 1000 - baseVideoTime
            self.setState({currentDateTime: utime + videoTime});
          };
          updateCurrentTime();
          if (self.updateCurrentTimeInterval) {
            clearInterval(self.updateCurrentTimeInterval);
            self.updateCurrentTimeInterval = null;
          }
          self.updateCurrentTimeInterval = setInterval(updateCurrentTime, 500);
        }
      });
      this.hls.on('SUBTITLE_CUE_CHANGE', function(event,data) {
        console.log('SUBTITLE_CUE_CHANGE');
        self.setState({'currentSubtitle': data.text});
      });
      //https://github.com/video-dev/hls.js/blob/master/doc/API.md#error-recovery-sample-code
      this.hls.on(Hls.Events.ERROR, function (event, data) {
        if (data.fatal) {
          switch(data.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
          // try to recover network error
            console.log('fatal network error encountered, try to recover');
            self.hls.startLoad();
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            console.log('fatal media error encountered, try to recover');
            self.hls.recoverMediaError();
            break;
          default:
          // cannot recover
            self.hls.destroy();
            break;
          }
        }
      });
      if (position === undefined) {
        video.onloadedmetadata = () => {
          video.currentTime = 0;
        };
      } else {
        video.onloadedmetadata = null;
      }
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // for s3 test
      const identityToken = this.state.identityToken;
      var expires = new Date();
      expires.setDate(expires.getDate() + 365);
      document.cookie = 'identity_token=' +identityToken +';path=/;domain=.tvapp.jp;expires=' + expires.toUTCString();
      //!
      video.src = videoUrl;
      video.addEventListener('loadedmetadata',function() {
        if (position !== undefined) {
          video.currentTime = position;
        }
        video.play();
      });
    }
    this.setState({status: 'play'});
  };
  playSubtitle = (videoUrl) => {
    if (this.subtitleHls !== undefined) {
      //this.subtitleHls.detachMedia();
      this.subtitleHls.destroy();
    }

    //videoUrl = 'http://192.168.2.101/cc/7fe27fe20410/caption.m3u8';
    const xhrSetup = (xhr, url) => {
      if (url.indexOf('video.key') !== -1) {
        xhr.withCredentials = true;
        xhr.open('GET', url, true);
      }
      else if (url.indexOf('"') !== -1) {
        url = url.replace(/"/g, '');
        xhr.open('GET', url, true);
      }
    };
    const video = document.getElementById('video');
    //this.subtitleHls.attachMedia(video);

    // 映像用Playlistをロードしたら、AribSubtitleStreamControllerに通知する
    var subtitleLoaded = false;
    var self = this;
    if (this.hls !== undefined) {
      this.hls.on(Hls.Events.LEVEL_LOADED, function(event, data) {
        if (subtitleLoaded) return;
        subtitleLoaded = true;
        const initPDT = moment(data.details.fragments[0].rawProgramDateTime).valueOf();
        const channelId = self.getChannelId(self.state.service);
        let subtitleUrl;
        if (self.state.videoType === 'live') {
          subtitleUrl = 'https://demo-cc01.tvapp.jp/apps/subpac/' +channelId +'/caption.m3u8';
        } else {
          const program = self.state.program;
          const startTime = moment(program.start_time*1000).format('YYYYMMDD-HHmmss000');
          subtitleUrl = 'https://demo-cc01.tvapp.jp/apps/subpac/' +channelId +'/' +startTime +'.m3u8';
        }
        const hlsConfig = {
          debug: true,
          subtitleStreamController: AribSubtitleStreamController,
          subtitleTrackController: AribSubtitleTrackController,
          useNativeRendering: false, // default false
          useAribSubtitleXml: false, // default false
          adjustWithPDT: true,
          xhrSetup: xhrSetup,
          media: video,
          initPDT: initPDT,
          subtitleUrl: subtitleUrl
        };
        self.subtitleHls = new Hls(hlsConfig);
      });
    }
    if (this.dashPlayer !== undefined) {
      this.dashPlayer.on(dashjs.MediaPlayer.events['MANIFEST_LOADED'],e => {
        console.log('availabilityStartTime', e.data.availabilityStartTime);
        if (subtitleLoaded) return;
        this.availabilityStartTime = e.data.availabilityStartTime;
        subtitleLoaded = true;
        const initPDT = moment(e.data.availabilityStartTime).valueOf();
        console.log('initPDT', initPDT);
        const channelId = self.getChannelId(self.state.service);
        let subtitleUrl;
        if (self.state.videoType === 'live') {
          // test
          subtitleUrl = 'https://demo-cc01.tvapp.jp/cc/7fe07fe00400/caption_ts_20180816193000000.m3u8';
        } else {
          const program = self.state.program;
          const startTime = moment(program.start_time*1000).format('YYYYMMDDHHmmss000');
          subtitleUrl = 'https://demo-cc01.tvapp.jp/cc/' +channelId +'/caption_ts_' +startTime +'.m3u8';
        }
        const hlsConfig = {
          debug: true,
          subtitleStreamController: AribSubtitleStreamController,
          subtitleTrackController: AribSubtitleTrackController,
          useNativeRendering: false, // default false
          useAribSubtitleXml: true, // default false
          adjustWithPDT: true,
          xhrSetup: xhrSetup,
          media: video,
          initPDT: initPDT,
          subtitleUrl: subtitleUrl
        };
        self.subtitleHls = new Hls(hlsConfig);

      });
    }
  }
  playWithDash = (videoUrl, position) => {

    const url = "sample/output.mpd";
    const player = dashjs.MediaPlayer().create();
    this.dashPlayer = player;
    var video = document.getElementById('video');
    player.initialize(video, url, true);

    // 字幕ロード
    this.playSubtitle(url);

    var self = this;
    this.dashPlayer.on(dashjs.MediaPlayer.events['PLAYBACK_PROGRESS'],e => {
      const utime = moment(self.availabilityStartTime).valueOf();
      const updateCurrentTime = () => {
        const videoTime = video.currentTime * 1000;
        self.setState({currentDateTime: utime + videoTime});
      };
      updateCurrentTime();
      if (self.updateCurrentTimeInterval) {
        clearInterval(self.updateCurrentTimeInterval);
        self.updateCurrentTimeInterval = null;
      }
      self.updateCurrentTimeInterval = setInterval(updateCurrentTime, 500);
    });
  };
  changeQuality = (quality) => {
    if (this.hls === undefined) {
      return;
    }
    this.hls.currentLevel = quality.level;
    this.setState({currentLevel: quality.level});
  };
  changeAudioTrack = (audioTrack) => {
    if (this.hls === undefined) {
      return;
    }
    this.hls.audioTrack = audioTrack.id;
    this.setState({currentAudioTrack: audioTrack.id});
  };
  changeSubtitle = (subtitleMode) => {
    if (this.hls === undefined) {
      return;
    }
    const video = document.getElementById('video');
    if (video) {
      // ここではforEachが使えない…？
      for (let i=0; i<video.textTracks.length; ++i) {
        video.textTracks[i].showMode = subtitleMode;
        // Dispatch the event.
        setTimeout(() => video.textTracks.dispatchEvent(new Event('change')), 0);
      }
    }
    this.setState({currentSubtitleMode: subtitleMode});
  }
  changePlaybackRate = (playbackRate) => {
    if (this.hls === undefined) {
      return;
    }
    const video = document.getElementById('video');
    if (video) {
      video.playbackRate = playbackRate;
    }
    this.setState({currentPlaybackRate: playbackRate});
  }
  onMouseEnter = () => {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
    }
    if (this.state.overlayFixed) return;
    this.setState({overlay: true});
    var self = this;
    this.timer = setTimeout(() => {
      self.setState({overlay: false});
    }, 2000);
  };
  onMouseLeave = () => {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
    }
    if (this.state.overlayFixed) return;
    var self = this;
    this.timer = setTimeout(() => {
      self.setState({overlay: false});
    }, 100);
  };
  onOverlayFixed = (fixed) => {
    //console.trace();
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
    }
    this.setState({overlayFixed: fixed});
    this.setState({overlay: fixed});
  }
  onFullscreenChanged = (event) => {
    const isFullscreen = (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) !== null;
    this.setState({isFullscreen: isFullscreen});
  }
  handleActivateSubmit = (data) => {
    var url = this.state.baseUrl +'/devices/activate.json';
    data['individual_id'] = this.state.individualId;
    var self = this;
    $.ajax({
      method:'post',
      url: url,
      data: data,
      dataType: 'text',
      cache: false,
      success: (data) => {
        self.setState({requireActivate: false});
        const pushId = self.getDummyPushId();
        self.registerDevice(pushId);
      },
      error: (xhr, status, err) => {
        console.error(url, status, err.toString());
      }
    });
  };
  onMultiModeChange = (isMulti) => {
    this.setState({isMulti: isMulti});
  }
  fetchChannels = () => {
    console.log('fetchChannels');
    const url = this.state.baseUrl +'/services.json';
    const data = {
      identity_token: this.state.identityToken,
      state: '東京都',
      city: '渋谷区',
      sub_locality: 'xxx',
      lat: 35.000,
      long: 130.00
    };
    const order = ['identity_token', 'state', 'city', 'sub_locality', 'lat', 'long', 'zipcode'];
    this.sign(data, order, this.state.identityTokenSecret, 'hash');
    var self = this;
    $.ajax({
      method:'get',
      url: url,
      data: data,
      dataType: 'json',
      cache: false,
      success: (data) => {
        self.setState({
          services: data,
          programGuide: data.program_guide,
          channelLoaded: true
        });
        //
        data.services.map(service => service.createChannelVideoUrl = self.createChannelVideoUrl);
        var service = data.services[0]; //初期番組
        //最後に選択したチャンネル
        //const activeServiceId = Cookies.get('activeServiceId');
        const activeServiceId = localStorage.getItem('activeServiceId');
        if (activeServiceId !== null || this.remoteKey !== undefined) {
          var results = self.remoteKey !== undefined?
            data.services.filter(service => service.remote_control_key_id.toString() === self.remoteKey) :
            data.services.filter(service => service.service_id === activeServiceId);
          if (results.length > 0) {
            service = results[0];
          }
        }
        const eventId = this.props.match.params.eventId;
        const querys = queryString.parse(this.props.location.search);
        const position = querys.t !== undefined? querys.t : 0;
        if (eventId !== undefined) {
          self.playProgramFromEventId(eventId, service, position);
        } else if (position !== 0) {
          const unixTime = moment(position, "YYYYMMDD-HHmmss").valueOf();
          self.playProgramFromUnixTime(service, unixTime);
        } else {
          self.playChannel(service);
        }
      },
      error: (xhr, status, err) => {
        console.error(url, status, err.toString());
      }
    });
  };
  fetchChannelProgram = (service, startTime, onProgramFetched) => {
    //this.setState({loading: true});
    const programGuide = this.state.programGuide;
    const channelId = service.original_network_id +"."+service.transport_stream_id +"."+service.service_id;
    const targetDate = startTime !== undefined? new Date(startTime): new Date();
    const date = moment(targetDate.getTime()).format('YYYYMMDD'); //yyyymmdd
    const hour = moment(targetDate.getTime()).format('HH');
    const duration = '6h';
    //http(s)://{EPG}/apps/epg/provider/{nid}.{tsid}.{sid}/{yyyy}{mm}{dd}/{hh}/{duration}.json
    const url = programGuide.index.base[0] +'/' +channelId +'/' +date +'/' +hour +'/' +duration +'.json';
    const self = this;
    //fetchIndex
    $.ajax({
      method:'get',
      url: url,
      dataType: 'json',
      cache: false,
      success: (data) => self.fetchProgramItem(data.event_id_list, true, startTime, onProgramFetched),
      error: (xhr, status, err) => console.error(url, status, err.toString())
    });
  };
  fetchProgramItem = (eventIdList, isCheckTime, startTime, onProgramFetched) => {
    if (eventIdList.length === 0) {
      return;
    }
    const eventIds = eventIdList.join(',');
    const programGuide = this.state.programGuide;
    const service = this.state.service;
    const channelId = service.original_network_id +'.' +service.transport_stream_id +'.' +service.service_id;
    // http(s)://{EPG}/apps/epg/provider/{nid}.{tsid}.{sid}/events.json?eid={event_ids}
    const url = programGuide.index.base[0] +'/' +channelId +'/events.json?eid=' +eventIds;
    var self = this;
    $.ajax({
      method:'get',
      url: url,
      dataType: 'json',
      cache: false,
      success: (data) => {
        const target = startTime !== undefined? new Date(startTime).getTime() : new Date().getTime();

        $(data).each(function() {
          const program = Object.values(this)[0];
          program.event_id = Object.keys(this)[0];
          if (isCheckTime) {
            if (target >= program.end_time*1000) {
              return true;
            }
            if (program.start_time*1000 <= target && target < program.end_time*1000) {
              self.setState({program: program});
              if (onProgramFetched) {
                onProgramFetched(program);
              }
              //self.props.onProgramInfoLoaded(program);
              return false;
            }
          } else {
            self.setState({program: program});
            if (onProgramFetched) {
              onProgramFetched(program);
            }
          }
        });

      },
      error: (xhr, status, err) => console.error(url, status, err.toString())
    });
  };
  createChannelVideoUrl = (service) => {
    const channelId = this.getChannelId(service);
    const data = {
      channel_id: channelId,
      identity_token: this.state.identityToken
    };
    const order = ['channel_id', 'identity_token'];
    this.sign(data, order, this.state.identityTokenSecret, 'hash');
    const videoUrl = service.live.main.endpoints[0]
      +'?channel_id=' + data.channel_id
      +'&identity_token=' +data.identity_token
      +'&hash=' +data.hash;
    return videoUrl;
  };
  createProgramVideoUrl = (program) => {
    const channelId = this.getChannelId(this.state.service);
    const startTime = moment(program.start_time*1000).format('YYYYMMDDHHmmss000');
    return 'https://d2rdcltn8gyl4k.cloudfront.net/tv/' +channelId +'/master_ts_' +startTime +'.m3u8' // demo
  };
  getChannelId = (service) => {
    return service.original_network_id + service.transport_stream_id + service.service_id;
  };
  componentDidMount = () => {
    const channelId = this.props.match.params.channelId;
    if (channelId !== undefined && channelId !== 'index.html') {
      if (channelId.length <= 3) {
        this.remoteKey = channelId;
      } else {
        localStorage.setItem('activeServiceId', channelId.substr(8));
      }
    }
    const querys = queryString.parse(this.props.location.search);
    this.debug = querys.debug === '1';
    this.fetchConfig();
    document.onfullscreenchange = this.onFullscreenChanged;
    document.onmozfullscreenchange = this.onFullscreenChanged;
    document.onwebkitfullscreenchange = this.onFullscreenChanged;
  };
  render = () => {
    let className = this.state.isMulti? "multi" : "";
    const menuStyle = {visibility: this.state.overlay? "visible": "hidden"};
    if (this.state.currentSubtitleMode === 'outside') {
      className += ' outside-subtitle';
    }
    return (
      <MuiThemeProvider muiTheme={theme}>
        <div id="mainContainer" className={className}>
          <div id="screenContainer">
            <div  id="innerContent">
              <DeviceRevoked
                status={this.state.status}
                individualId={this.state.individualId}
              />
              <ActivateForm
                requireActivate={this.state.requireActivate}
                onSendSubmit={this.handleActivateSubmit}
              />
              <VideoArea
                channelLoaded={this.state.channelLoaded}
                services={this.state.services}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                overlay={this.state.overlay}
                onOverlayFixed={this.onOverlayFixed}
              />
              <VideoPlayback
                channelLoaded={this.state.channelLoaded}
                overlay={this.state.overlay}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
              />
              <div id="menu-background" style={menuStyle}/>
              <Channels
                channelLoaded={this.state.channelLoaded}
                services={this.state.services}
                activeServiceId={this.state.activeServiceId}
                onSelectChannel={this.playChannel}
                overlay={this.state.overlay}
                onOverlayFixed={this.onOverlayFixed}
                isFullscreen={this.state.isFullscreen}
              />
              <VideoTitle
                overlay={this.state.overlay}
                videoType={this.state.videoType}
                service={this.state.service}
                program={this.state.program}
                onBackToLive={this.playChannel}
                onPlayFromStart={this.playProgram}
                onOverlayFixed={this.onOverlayFixed}
                isFullscreen={this.state.isFullscreen}
              />
              <VideoStatus
                overlay={this.state.overlay}
                videoType={this.state.videoType}
                service={this.state.service}
                program={this.state.program}
                onBackToLive={this.playChannel}
                onPlayFromStart={this.playProgram}
                onPlayFromPosition={this.playProgram}
                onOverlayFixed={this.onOverlayFixed}
                currentDateTime={this.state.currentDateTime}
              />
              <VideoControls
                overlay={this.state.overlay}
                onOverlayFixed={this.onOverlayFixed}
                muted={this.state.muted}
                isFullscreen={this.state.isFullscreen}
                audioTracks={this.state.audioTracks}
                currentAudioTrack={this.state.currentAudioTrack}
                onSelectAudioTrack={this.changeAudioTrack}
                qualityLevels={this.state.qualityLevels}
                currentLevel={this.state.currentLevel}
                onSelectQuality={this.changeQuality}
                currentSubtitleMode={this.state.currentSubtitleMode}
                onChangeSubtitle={this.changeSubtitle}
                currentPlaybackRate={this.state.currentPlaybackRate}
                onChangePlaybackRate={this.changePlaybackRate}
                />
              <Programs
                services={this.state.services}
                service={this.state.service}
                videoType={this.state.videoType}
                program={this.state.program}
                onLoadPrograms={this.onLoadPrograms}
                programGuide={this.state.programGuide}
                onSelectProgram={this.playProgram}
                overlay={this.state.overlay}
                onOverlayFixed={this.onOverlayFixed}
                isFullscreen={this.state.isFullscreen}
              />
              <Detail
                overlay={this.state.overlay}
                onOverlayFixed={this.onOverlayFixed}
                program={this.state.program}
                isFullscreen={this.state.isFullscreen}
              />
            </div>
          </div>
          <OutsideSubtitle
            currentSubtitle={this.state.currentSubtitle}
            currentSubtitleMode={this.state.currentSubtitleMode}
          />
        </div>
        <ProgramLink
          program={this.state.program}
          service={this.state.service}
          programs={this.state.programs}
          currentSubtitle={this.state.currentSubtitle}
          currentDateTime={this.state.currentDateTime}
          isMulti={this.state.isMulti}
          onSelectProgram={this.playProgram}
        />
        <MultiVideoArea
          services={this.state.services}
          service={this.state.service}
          onSelectChannel={this.playChannel}
          onMultiModeChange={this.onMultiModeChange}
          onOverlayFixed={this.onOverlayFixed}
          overlay={this.state.overlay}
        />
        <div id="subtitle-debug-view"></div>
        <div id="drcs" style={{display:"inlineBlock",width:"20%",float:"right"}}></div>
      </MuiThemeProvider>
    );
  };
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js